import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermissionRefreshService {
  private refreshSubject = new Subject<void>();
  
  // Observable for components to subscribe to
  refresh$ = this.refreshSubject.asObservable();
  
  // Method to trigger permission refresh
  triggerRefresh(): void {
    this.refreshSubject.next();
  }
}
